module.exports = __webpack_public_path__ + "img/icon11.72963021.svg";